import { useEffect } from 'react';
import { isEmpty } from 'lodash';

export default (errors, submitCount, previousCount) => {
  useEffect(() => {
    if (!isEmpty(errors) && submitCount !== previousCount) {
      const element = document.getElementsByName(Object.keys(errors)[0])[0];
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [errors, submitCount, previousCount]);
};
